import LRU from 'lru-cache'
import { withCache } from '@wix/thunderbolt-commons'
import type { FetchFn, Logger, MetricsReporter } from '@wix/thunderbolt-becky-types'

export const BeckyFetch = (
	fetch: FetchFn,
	metricsReporter: MetricsReporter,
	options: LRU.Options<string, string> = { max: 300 }
): FetchFn => {
	const { ...lruOptions } = options
	const cache = new LRU<string, string>(lruOptions)

	return withCache(fetch, cache, metricsReporter, 'becky_fetch_cache')
}
